import type { FC } from 'react';
import { useEffect, useRef } from 'react';
import type { IAutoScrollerProps } from './type';

export const AutoScroller: FC<IAutoScrollerProps> = (props) => {
  // props
  const {
    children,
    behavior = 'smooth',
    block = 'nearest',
    enabled = true,
    ...attrs
  } = props;
  // ref
  const containerRef = useRef<HTMLElement>(null);
  // effect
  useEffect(() => {
    if (enabled && containerRef.current) {
      containerRef.current.scrollIntoView({ behavior, block });
    }
  }, []);

  return (
    <section {...attrs} ref={containerRef}>
      {children}
    </section>
  );
};
